import { Component } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams, RowNode } from 'ag-grid-community';

@Component({
  selector: 'app-header-checkbox-cell-renderer',
  templateUrl: './header-checkbox-cell-renderer.component.html',
  styleUrl: './header-checkbox-cell-renderer.component.scss',
})
export class HeaderCheckboxCellRendererComponent implements IHeaderAngularComp {
  params!: IHeaderParams;
  checked: boolean = false;

  agInit(params: IHeaderParams): void {
    this.params = params;
  }

  refresh(): boolean {
    return true;
  }

  onCheckboxChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.checked = input.checked;

    const field = this.params.column.getColDef().field;

    this.params.api.forEachNode((node: RowNode) => {
      if (node.data?.status !== 'Completed') {
        //  Select/deselect the row
        node.setSelected(this.checked);

        // Update the checkbox column value
        node.setDataValue(field!, this.checked);
      }
    });

    // Refresh cells to reflect checkbox change
    this.params.api.refreshCells({ columns: [field!], force: true });
  }
}
